import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const PresentationView = lazy(() =>
  import('@/components/presentation-view').then((m) => ({ default: m.PresentationView })),
)

export const Route = createFileRoute('/p/$id')({
  component: PresentationPage,
  head: () => ({
    meta: [
      { title: 'Presentation — mkdn.app' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
})

function PresentationPage() {
  const { id } = Route.useParams()
  return (
    <main className="min-h-screen flex flex-col">
      <Suspense fallback={<div className="p-6 text-muted-foreground">Loading presentation…</div>}>
        <PresentationView documentId={id} />
      </Suspense>
    </main>
  )
}
